import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import FullLoader from 'components/loader/full-loader';

const PermissionMiddleware = ({
  allowedRoles = [],
  allowedPermissions = [],
  children,
  fallback = null // If fallback is provided, it is assumed to be for routes
}) => {
  const { user, loading } = useAuth();

  // Tampilkan loader saat data pengguna sedang diambil
  if (loading) {
    return <FullLoader />;
  }

  // Jika user belum login, redirect ke halaman unauthorized (ini untuk semua, komponen dan route)
  if (!user) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Memeriksa apakah user memiliki role yang diizinkan
  // const hasValidRole = allowedRoles.length === 0 || allowedRoles.some(role => user.roles?.includes(role));
  const hasValidRole = allowedRoles.length === 0 || allowedRoles.some(role => user.roles?.some(r => r.name === role));

  // console.log("PermissionMiddleware hasValidRole", user);  // Pastikan `roles` ada dan berisi data yang benar


  // Memeriksa apakah user memiliki permission yang diizinkan
  // const hasValidPermission = allowedPermissions.length === 0 || allowedPermissions.some(permission => user.permissions?.includes(permission));
  const hasValidPermission = allowedPermissions.length === 0 || allowedPermissions.some(permission => user.permissions?.some(p => p.name === permission));
  // console.log("PermissionMiddleware hasValidPermission", user);  // Pastikan `permissions` ada dan berisi data yang benar

  // Jika user tidak memiliki role atau permission yang sesuai
  if (!hasValidRole || !hasValidPermission) {
    // Jika fallback disediakan, berarti ini digunakan di route
    if (fallback) {
      return fallback; // Tampilkan komponen fallback (misalnya halaman Unauthorized)
    }
    // Jika tidak ada fallback, ini digunakan di komponen -> return null agar tidak dirender
    return null;
  }

  // Jika semua persyaratan terpenuhi, render child component
  return children;
};

export default PermissionMiddleware;
